import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ResourceService } from '../../../../services/resources/resource.service';
import { ResourceSearchRequest } from '../../../../models/net/request/resource-search-request';
import { ResourceSearchResult } from '../../../../models/net/result/resource-search-result';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestService } from '../../../../services/search-requests/search-request.service';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { ItemEnvelope } from '../../../../models/net/envelope/base/item-envelope';
import { SearchRequestSearchRequest } from '../../../../models/net/request/search-request-search-request';
import { SearchRequest } from '../../../../models/data/app-core/search-request';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestBase } from '../../../../models/net/request/base/search-request-base';
import { SearchRequestDocument } from '../../../../models/net/envelope/documents/search-request-document';
import { SearchRequestType } from '../../../../models/data/app-core/search-request-type';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.css', '../../../../app.component.css']
})

export class ResourcesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "FirstName", "LastName", "Delete"];
    public override searchResult: ResourceSearchResult[] = [];
    public searchRequestEnvelopes: SearchRequestEnvelope[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.ResourceSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "ResourceSearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: ResourceService, public searchRequestService: SearchRequestService) {

        super(appService, sessionService, itemService, "resource", "Resource");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.ResourceSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const resourceSearchRequest: ResourceSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(resourceSearchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: ResourceSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: ResourceSearchResult) => i.ResourceId).indexOf(id, 0);

        return result;
    }

    public runSearch = (resourceSearchRequest: ResourceSearchRequest): void => {

        this.searchRequest = resourceSearchRequest;

        this.search();
    }
}
